import { servicesAPI } from "./api"
import { getWorkspaceId } from "../util/GetWorkspaceId"
import { parseServicesCallbackWithValue } from "./api/services"

export const search = (searchString: string): Promise<string> =>
    servicesAPI.postJSON(
        "Search",
        { searchString, workspaceId: getWorkspaceId() },
        parseServicesCallbackWithValue<string>,
    )
